import { Skeleton } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import "./skeleton.scss";

const DashboardTableSkaleton = ({ count, className }) => {
  const skeletonHeights = Array.from(
    { length: count },
    (_, index) => 50 - index * 3
  );

  return (
    <Stack spacing={1} className={className || "skaleton-table"}>
      {skeletonHeights.map((height, index) => (
        <Skeleton key={index} variant="rectangular" height={height} />
      ))}
    </Stack>
  );
};

DashboardTableSkaleton.defaultProps = {
  count: 15,
};

export default DashboardTableSkaleton;
